import { useState } from "react";
import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, ShoppingBag, MessageSquare, Mail, Users, Package,
  Wrench, FileText, Youtube, Star, Settings, LogOut, Menu, X, Loader2,
} from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
  { to: "/admin/emails", label: "Email Centre", icon: Mail },
  { to: "/admin/subscribers", label: "Subscribers", icon: Users },
  { to: "/admin/products", label: "Products & Pricing", icon: Package },
  { to: "/admin/gear", label: "Recommended Gear", icon: Wrench },
  { to: "/admin/resources", label: "Free Resources", icon: FileText },
  { to: "/admin/videos", label: "Videos", icon: Youtube },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/settings", label: "Site Settings", icon: Settings },
];

export default function AdminLayout() {
  const { admin, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  if (admin === null) return <div className="min-h-screen grid place-items-center bg-[#0A0A0A]"><Loader2 className="animate-spin text-[#D4AF37]" /></div>;
  if (!admin || !admin.email) return <Navigate to="/admin/login" replace />;

  const doLogout = async () => { await logout(); nav("/admin/login"); };

  const Sidebar = () => (
    <div className="flex flex-col h-full">
      <div className="p-6 border-b border-white/10">
        <div className="font-display font-bold tracking-[0.15em] gold-text text-xl">QWERJOH</div>
        <div className="text-[9px] uppercase tracking-[0.3em] text-white/40 mt-0.5">Admin Panel</div>
      </div>
      <nav className="flex-1 overflow-y-auto p-3 space-y-1">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
            className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-[#D4AF37]/15 text-[#D4AF37]" : "text-white/70 hover:bg-white/5"}`}>
            <n.icon size={18} strokeWidth={1.6} /> {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-3 border-t border-white/10">
        <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-white/70 hover:bg-white/5">
          <LogOut size={18} /> Sign out
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex">
      <aside className="hidden lg:block w-64 shrink-0 border-r border-white/10 bg-[#0d0d0d] fixed inset-y-0"><Sidebar /></aside>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="w-64 bg-[#0d0d0d] border-r border-white/10"><Sidebar /></div>
          <div className="flex-1 bg-black/60" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden sticky top-0 z-40 glass flex items-center justify-between px-4 h-14">
          <button onClick={() => setOpen(true)}><Menu /></button>
          <div className="font-display gold-text tracking-widest">QWERJOH</div>
          <div className="w-6" />
        </header>
        <div className="p-4 sm:p-8 max-w-[1400px]"><Outlet /></div>
      </div>
    </div>
  );
}
